<template>
  <main
    class="the-input-wrapper"
    :class="{
      'the-input-wrapper--disabled': disabled,
      'the-input-wrapper--locked': locked,
      'the-input-wrapper--textarea': type === 'textarea',
      'the-input-wrapper--left': leftPos,
      'checkbox-wrapper': type === 'checkbox',
    }"
    :ref="inputId"
    :title="(!showDropdown && fixedLabel) || ''"
  >
    <label :for="inputId" v-if="label">{{ label }}</label>

    <template v-if="type === 'checkbox'">
      <input
        :id="inputId"
        type="checkbox"
        :checked="value"
        :disabled="disabled"
        @change="$emit('change', $event.target.checked)"
      />
      <span
        @click="!disabled && $emit('change', !value)"
        class="checkmark"
      ></span>
    </template>
    <div
      v-else
      class="the-input"
      :class="{
        'the-input--disabled': disabled,
        'the-input--as-icon': showAsIcon,
        'the-input--dark': dark,
        'the-input--invalid': invalid,
      }"
      ref="theInput"
      @click.stop="toggleDropdown"
    >
      <span v-if="icon" class="mck input-icon">{{ icon }}</span>
      <span
        v-if="showAsIcon"
        class="mck"
        :class="{ 'mck--active': showDropdown }"
        >{{ showAsIcon }}</span
      >

      <template v-if="!showAsIcon">
        <input
          v-if="options"
          :id="inputId"
          type="text"
          :readonly="true"
          :disabled="disabled"
          :placeholder="getValue"
        />
          <!-- :readonly="locked || !showDropdown" -->

        <input
          v-else-if="type === 'datepicker'"
          class="date"
          type="text"
          id="newReportDate"
          :placeholder="placeholder"
          :value="getValue"
          :disabled="disabled"
          readonly
        />

        <textarea
          v-else-if="type === 'textarea'"
          :id="inputId"
          :rows="textareaRows || 2"
          type="text"
          :maxlength="maxlength"
          :placeholder="placeholder"
          :value="value"
          :readonly="locked"
          :disabled="disabled"
          @input="emitInput"
        />
        <input
          v-else
          :id="inputId"
          type="text"
          :disabled="disabled"
          :maxlength="maxlength"
          :readonly="locked"
          :placeholder="getValue"
          :value="value"
          @input="emitInput"
        />
      </template>

      <TheModal
        v-if="type === 'datepicker' && showDropdown"
        :onlyCancel="true"
        :title="label"
        size="small"
        @close="handleClose"
      >
        <div
          class="new-input-dropdown datepicker-dropdown"
          :class="{ 'datepicker-dropdown-active': showDropdown }"
        >
          <datepicker
            :language="bg"
            :inline="true"
            :monday-first="true"
            :wrapper-class="'custom-datepicker'"
            :calendar-class="'custom-calendar'"
            :disabled-dates="getDisabledDates()"
            v-model="selectedDate"
            @selected="emitValue()"
          ></datepicker>
        </div>
      </TheModal>

      <template v-if="fixed">
        <!-- could be changed as a regular dropdown -->
        <TheFixedDropdown
          v-if="showDropdown"
          prop="name"
          :label="fixedLabel"
          :propValue="propValue"
          :isSort="isSort"
          :value="value"
          :arr="getList"
          @selected="emitValue($event)"
          @close="handleClose()"
        />
      </template>
      <template v-else>
        <TheModal
          v-if="options && showDropdown"
          :onlyCancel="true"
          size="medium"
          @close="handleClose"
        >
          <main class="dropdown-menu">
            <input
              @click.stop
              class="input--search"
              type="text"
              placeholder="Търсене...."
              v-model="search"
            />
            <p
              v-for="(option, i) in getList"
              :key="`${option}-${i}`"
              @click.stop="emitValue(option)"
            >
              <span
                class="dropdown-menu_icon"
                :class="option.iconClass || 'mck'"
                v-if="option.icon || iconOptions"
                >{{ option.icon || iconOptions }}</span
              >
              <span>{{ prop ? option[prop] : option }}</span>
            </p>
          </main>
        </TheModal>

        <aside v-if="options && !showAsIcon">
          <span v-if="disabled || locked" class="mck">A</span>
          <span
            v-else-if="value && canRemove"
            @click.stop="emitValue('')"
            class="mck"
            >b</span
          >
          <span
            v-else
            class="mck mck--arrow"
            :class="{ 'mck--arrow-active': showDropdown }"
          >
            M
          </span>
        </aside>
      </template>
    </div>
  </main>
</template>

<script>
import TheFixedDropdown from "@/components/TheFixedDropdown";
import TheModal from "@/components/shared/TheModal";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    TheFixedDropdown,
    Datepicker,
    TheModal,
  },
  props: [
    "value",
    "options",
    "label",
    "prop",
    "propValue",
    "placeholder",
    "type",
    "maxlength",
    "disabled",
    "locked",
    "icon",
    "iconOptions",
    "fixed",
    "fixedLabel",
    "isSort",
    "canRemove",
    "showAsIcon",
    "invalid",
    "dark",
    "leftPos",
    "disabledDates",
    "digitsOnly",
    "textareaRows",
  ],
  computed: {
    getList() {
      if (this.prop) {
        return this.options.filter((x) =>
          x[this.prop]
            .toLowerCase()
            .includes(this.search ? this.search.toLowerCase() : "")
        );
      } else if (!this.prop) {
        return this.options.filter((x) =>
          x.toLowerCase().includes(this.search ? this.search.toLowerCase() : "")
        );
      }
      return this.options;
    },
    getValue() {
      if (this.type === "datepicker") {
        return this.selectedDate
          ? format(new Date(this.selectedDate), "dd/MM/yyyy")
          : this.placeholder;
      } else if (this.type === "dropdown") {
        if (this.isSort) return this.placeholder;
        else if (this.propValue) {
          let el = this.options.find((o) => o[this.propValue] === this.value);
          return el ? (this.prop ? el[this.prop] : el) : this.placeholder;
        } else if (this.prop) {
          return this.value && this.value[this.prop] !== undefined
            ? this.value[this.prop]
            : this.placeholder;
        } else {
          return this.value !== undefined &&
            this.value !== null &&
            this.value !== ""
            ? this.value
            : this.placeholder;
        }
      } else {
        return this.value !== undefined &&
          this.value !== null &&
          this.value !== ""
          ? this.value
          : this.placeholder;
      }
    },
  },
  data() {
    return {
      // selected: "",
      bg,
      inputId: `input-${Math.random().toString(36).substr(2, 9)}`,
      search: "",
      showDropdown: false,
      selectedDate: this.value,
    };
  },
  methods: {
    emitInput(e) {
      if (this.digitsOnly) {
        // accept int and float numbers
        e.target.value = e.target.value
          .replace(/[^0-9.]/g, "")
          .replace(/(\..*)\./g, "$1");
      }

      this.$emit("input", e.target.value);
    },
    toggleDropdown() {
      if (!this.locked && ["datepicker", "dropdown"].includes(this.type)) {
        if (this.type === "datepicker") {
          if (!this.showDropdown)
            this.showDropdown = this.disabled ? false : true;
        } else {
          this.showDropdown = this.disabled ? false : true;
        }
      }
      this.$emit("click");
    },
    getDisabledDates() {
      if (this.disabledDates) {
        return this.disabledDates;
      }

      return {};
    },
    emitValue(option) {
      this.handleClose();

      this.$nextTick(() => {
        if (this.type === "datepicker") {
          this.$emit("update:modelValue", this.selectedDate);
        } else {
          if (this.isSort) {
            if (this.value[option.value] === -1 || option.remove) {
              delete this.value[option.value];
            } else if (this.value[option.value] === 1) {
              this.value[option.value] = -1;
            } else {
              this.value[option.value] = 1;
            }

            this.$emit("update:modelValue", { ...this.value });
          } else {
            this.$emit("update:modelValue", option);
          }
        }
      });
    },
    handleClose() {
      setTimeout(() => {
        // if (!this.fixed) this.showDropdown = false;
        this.search = ''
        this.showDropdown = false;
      }, 100);
    },
  },
};
</script>

<style lang="scss">
.the-input-wrapper {
  &.the-input-wrapper--disabled,
  &.the-input-wrapper--locked {
    cursor: default;

    &:not(.the-input-wrapper--locked) {
      opacity: 0.5;
    }

    input,
    textarea,
    label {
      cursor: inherit;
    }
  }

  &.the-input-wrapper--textarea {
    .the-input {
      height: fit-content;
    }
  }

  &.the-input-wrapper--left {
    .datepicker-dropdown-active {
      left: 0;
      transform: scaleY(1);
    }
  }

  .datepicker-dropdown {
    position: initial;
    margin: 0 auto;
    min-width: 200px;
    max-width: 240px;

    &.datepicker-dropdown-active {
      border-color: inherit;

      .custom-datepicker {
        padding: 5px;

        .cell {
          line-height: 30px;
          height: 30px;
        }
      }
    }
  }

  label {
    color: #373737;
    font-weight: 700;
    display: inline-block;
    margin: 5px 0;
  }
  .the-input {
    align-items: center;
    border: 1px solid #3a6ebe;
    background: #d3e8f6;
    border-radius: 4px;
    display: flex;
    height: 35px;
    position: relative;

    &.the-input--invalid {
      border-color: inherit;
      background-color: #f8dcdc;
      color: #d91313;

      .mck {
        color: #d91313;
      }

      input,
      textarea {
        &::placeholder {
          color: #d91313;
        }
      }
    }

    &.the-input--dark {
      background: #f4f4f4;
      border: none;
    }

    &.the-input--disabled {
      aside {
        .mck {
          cursor: default;
          transform: initial;
        }
      }
    }
    &.the-input--as-icon {
      background: initial;
      border: initial;
      cursor: pointer;
      height: fit-content;

      > .mck {
        background: #3b86ff;
        border-radius: 4px;
        color: #ffffff;
        font-size: 16px;
        padding: 5px;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;

        &.mck--active {
          transform: scale(-1);
        }
      }
    }

    > .input-icon {
      color: var(--color-main);
      font-size: 16px;
      padding-left: 10px;
      width: 25px;
    }
    aside {
      align-items: center;
      background: #e3e8f1;
      border-left: 1px solid #ccd1e3;
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
      display: flex;
      height: calc(100% - 1px);
      justify-content: center;
      padding: 0 8px;

      .mck {
        color: #242424;
        cursor: pointer;
        font-size: 20px;
        user-select: none;
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -ms-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;

        &.mck--arrow {
          transform: rotate(90deg);

          &.mck--arrow-active {
            transform: rotate(-90deg);
          }
        }
      }
    }

    input,
    textarea {
      background: inherit;
      border: none;
      border-radius: inherit;
      flex-grow: 1;
      font-size: 11px;
      font-family: "Google Sans";
      resize: none;
      font-weight: bold;
      height: 100%;
      padding: 8px 12px;

      &.input--search {
        background: #f4f4f4;
      }
    }

    .dropdown-menu {
      display: flex;
      flex-direction: column;
      gap: 3px;
      padding: 5px;
      width: 100%;

      input {
        margin-bottom: 15px;
      }

      p {
        align-items: center;
        background: #e4edf3;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        gap: 10px;
        padding: 5px;

        &.option--asc,
        &.option--desc {
          background: #4081ac;
          color: white;
        }

        &.option--desc {
          background: #406bac;
        }

        .dropdown-menu_icon {
          font-size: 18px;

          &.mck--delete {
            flex-grow: 2;
            font-size: 15px;
            text-align: right;
          }
        }

        &:hover:not(.option--asc):not(.option--desc) {
          background: #d3e8f6;
        }
      }
    }
  }
}
</style>
